"use client";

import {
	SidebarGroup,
	SidebarGroupLabel,
	SidebarMenu,
} from "@/components/ui/sidebar";
import { m } from "@/paraglide/messages";
import { CollapsibleItem, type NavAreaItem } from "./NavItems";

export function NavAdminArea({ items }: { items: NavAreaItem[] }) {
	return (
		<SidebarGroup>
			<SidebarGroupLabel>{m.tiny_caring_hyena_shine()}</SidebarGroupLabel>
			<SidebarMenu>
				{items.map((item) => (
					<CollapsibleItem item={item} key={item.title} />
				))}
			</SidebarMenu>
		</SidebarGroup>
	);
}
